import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse, Button } from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import IconWithText from 'components/Widgets/IconWithText';
import ExternalLink from 'components/Widgets/ExternalLink';
import confirmAlert from 'components/new_ui/Alerts/confirm';
import Alert from 'components/new_ui/Alerts/alert';

export default function Archive({ assessments, setAssessments }) {
  const [open, setOpen] = useState(false);

  const dateFormat = (value) => {
    if (!value) {
      return null;
    }

    const date = new Date(value);
    const options = { dateStyle: 'long', timeStyle: 'short' };

    return new Intl.DateTimeFormat('en-US', options).format(date);
  };

  if (assessments.length === 0) {
    return null;
  }

  const removeAssessment = (id, name) => {
    confirmAlert(
      {
        title: 'Remove External Assessment',
        text: `Do you want to delete "${name}"?`,
        confirmButtonText: 'Delete',
      },
      () => {
        axios
          .delete(routes.api.members.assessments.destroy(id))
          .then((_response) => {
            setAssessments(assessments.filter((assessment) => assessment.id !== id));
            Alert({
              text: 'External Assessment has been successfully removed!',
            });
          });
      },
    );
  };

  return (
    <>
      <Button
        variant="link"
        className="d-flex mb-3 collapsed text-decoration-none text-gray-900"
        onClick={() => setOpen(!open)}
        data-bs-toggle="collapse"
        data-bs-target="#external-assessments-list"
        aria-controls="external-assessments-list"
        aria-expanded={open}
      >
        {open ? 'Hide' : 'Show'}
        {' '}
        List

        <IconWithText
          iconClassName="chevron-icon small-icon icon-toggle"
          wrapperClassName="ms-2"
        />
      </Button>

      <Collapse in={open}>
        <ul
          id="external-assessments-list"
          className="list-unstyled"
        >
          {assessments.map((assessment) => (
            <li key={assessment.id}>
              <IconWithText
                iconClassName="article-icon bg-secondary"
                iconBg="medium-bg bg-gray-100"
                wrapperClassName="mb-3"
              >
                <>
                  <div className="small text-gray-700">
                    {dateFormat(assessment.attributes.created_at)}
                  </div>

                  <div className="d-flex align-items-center">
                    <ExternalLink
                      variant={null}
                      href={assessment.attributes.url}
                    >
                      {assessment.attributes.file_name}
                    </ExternalLink>

                    <Button
                      variant="link"
                      className="ms-2"
                      onClick={() => removeAssessment(assessment.id, assessment.attributes.file_name)}
                    >
                      <IconWithText
                        iconClassName="trash-icon small-icon bg-danger"
                      />
                    </Button>
                  </div>
                </>
              </IconWithText>
            </li>
          ))}
        </ul>
      </Collapse>
    </>
  );
}

Archive.propTypes = {
  assessments: PropTypes.arrayOf(PropTypes.object).isRequired,
  setAssessments: PropTypes.func.isRequired,
};
